var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1089,
    height: 1080,
    viewBox: "0 0 1089 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 652.021,
    y: -5.74457,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 652.021 -5.74457)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1110.59,
    y: 161.161,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 1110.59 161.161)",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 479.643,
    y: 467.861,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 479.643 467.861)",
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 967.496,
    y: -159.094,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 967.496 -159.094)",
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 938.213,
    y: 634.766,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 938.213 634.766)",
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 795.117,
    y: 314.511,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 795.117 314.511)",
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 357.068,
    y: 91.2235,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 357.068 91.2235)",
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 622.74,
    y: 788.116,
    width: 220,
    height: 480,
    rx: 110,
    transform: "rotate(20 622.74 788.116)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingBg1);
export default __webpack_public_path__ + "static/media/onboarding-bg1.63ae947406bf7875bde497cf7609f4be.svg";
export { ForwardRef as ReactComponent };